module.exports = __webpack_public_path__ + "img/uber.9536389c.png";